import React from "react";

import { Select } from "~/components/select";
import { SelectContent } from "~/components/select/content";
import { SelectItem } from "~/components/select/item";
import { SelectTrigger } from "~/components/select/trigger";
import { SelectValue } from "~/components/select/value";
import { ALL_CALCULATIONS } from "~/tools/calculate-value-from-points";
import { useScope } from "~/tools/impulse";

import type { WidgetCalculation } from "./form-state";

export interface WidgetCalculationFieldProps {
	name: string;
	calculation: WidgetCalculation;
}

export const WidgetCalculationField: React.FC<WidgetCalculationFieldProps> = ({ name, calculation }) => {
	const scope = useScope();

	return (
		<Select name={name} onValueChange={(input) => calculation.setInput(input)} value={calculation.getInput(scope)}>
			<SelectTrigger>
				<SelectValue />
			</SelectTrigger>

			<SelectContent>
				{ALL_CALCULATIONS.map((value) => (
					<SelectItem key={value} value={value}>
						{value}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
